import { ProfileV1 } from './profile-v1';

export class Profile extends ProfileV1 {
    // TODO: add new implementation
}
